<template>
    <div class="user-management-wrapper">
        <h2>User Management</h2>
        <hr>
        <div class="d-flex justify-content-between mb-2">
            <div class="btn btn-secondary cursor" @click="$router.back()">Back</div>
            <div class="btn btn-primary cursor" @click="loadNewUserModal">Create Admin</div>
        </div>
        <div class="user-management">
            <BasicDataGrid
                    :dataSource="users"
                    :columns="columns"
                    :multiSelect="false"
                    :showColumnLines="false"
                    :searchEntireGrid="false"
                    :actions="actions"
            />
        </div>
        <Modal ref="userModal">
            <AdminUsersEdit :user="tempUser" :users="users" v-on:update:success="handleAdminUserUpdateSuccess"/>
        </Modal>
    </div>

</template>

<script>
    import { mapState }     from 'vuex';

    import { AdminUserService } from '@/services';
    import BasicDataGrid    from '@/components/BasicDataGrid.vue';
    import AdminUsersEdit   from '@/views/dashboard/admins/AdminUsersEdit.vue';


    export default {
        name: "AdminUsers",
        components: {
            BasicDataGrid,
            AdminUsersEdit,
        },
        data: () => {
            return {
                actions: [
                    // {
                    //     hint: 'Edit',
                    //     icon: 'edit',
                    //     emit: 'editUser',
                    // },
                ],
                columns: [
                    { text: 'First Name'  , value: 'FirstName'   },
                    { text: 'Last Name'   , value: 'LastName'    },
                    { text: 'Email'       , value: 'Email'       },
                    { text: 'Phone'       , value: 'MobilePhone' },
                    { text: 'Created Date' , value: 'CreatedDate', dataType: 'date', format: 'shortDate' },
                    { text: 'Last Logon Date' , value: 'LastLogonDate', dataType: 'date', format: 'shortDate' },
                ],
                users: [],
                tempUser: {},
            }
        },
        computed: {
            ...mapState(['currentUser'])
        },
        methods: {
            getAdminUsers(){
                AdminUserService.all().then(res => {
                    //console.log(res);
                    this.users = res;
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
                })
            },
            loadNewUserModal(){
                this.clearTempUser();
                this.$refs.userModal.toggle();
            },
            // loadEditUserModal(e){
            //     let user = e.row.data;
            //     this.clearTempUser();
            //     this.tempUser = user;
            //     this.$refs.userModal.toggle();
            // },
            clearTempUser(){
                this.tempUser = {};
            },
            closeModal(){
                this.$refs.userModal.toggle();
            },
            handleAdminUserUpdateSuccess(){
                this.getAdminUsers();
                this.closeModal();
            }
        },
        mounted(){
            this.getAdminUsers();
        }
    }
</script>

<style scoped lang="scss">
    .user-management-wrapper {
        max-width: 800px;
    }
</style>

